import { useEffect, useState } from "react"

import { useDispatch, useSelector } from "react-redux"

import { selectGlobalFilters, selectTestData } from "../../GlobalFilters/redux/globalFilters.slice"
import {
  selectAdminDeflectCard,
  selectAdminDeflectCardFetching,
  selectAdminDeflectFilters
} from "../redux/adminDeflectAnalytics.slice"
import { CARD_THUNKS } from "../redux/adminDeflectAnalytics.thunks"
import { toAdminDeflectQuery } from "../utils/queryParams"

// The rows of a list page (CHA1-4558).
export const LIST_PAGE_SIZE = 8

// The filters' query by value: a re-render with the same filters gives the same string.
const useQuery = () => {
  const filters = useSelector(selectAdminDeflectFilters)
  const userEmails = useSelector(selectGlobalFilters).user_email
  const testData = useSelector(selectTestData)

  return JSON.stringify(toAdminDeflectQuery(filters, userEmails, testData))
}

// A card's data: requested when the page opens and again on every filter change, never on a timer
// (DAA-1-10). `loading` is true while a request is in flight; the previous data stays meanwhile.
// `page` asks for one page of a list.
export const useCardData = (key, page = null) => {
  const dispatch = useDispatch()
  const query = useQuery()

  // A newer filter change or page cancels the request still in flight.
  useEffect(() => {
    const params = JSON.parse(query)

    if (page !== null) {
      params.page = page
      params.page_size = LIST_PAGE_SIZE
    }

    const request = dispatch(CARD_THUNKS[key](params))

    return () => request.abort()
  }, [dispatch, key, query, page])

  const data = useSelector(selectAdminDeflectCard(key))
  const loading = useSelector(selectAdminDeflectCardFetching(key))

  return { data, loading }
}

// A card's list, a page at a time: each list keeps its own page, and a filter change takes it back
// to the first one (CHA1-4558).
export const useListData = (key) => {
  const query = useQuery()
  const [page, setPage] = useState(1)
  const [pageQuery, setPageQuery] = useState(query)

  // Reset while rendering, not in an effect: the request then goes out for page 1 straight away,
  // never for the old page under the new filters.
  if (pageQuery !== query) {
    setPageQuery(query)
    setPage(1)
  }

  const { data, loading } = useCardData(key, page)

  return { data, loading, page, setPage }
}
